import MokuNotePanel from './MokuNotePanel'

export default MokuNotePanel